import React, { useContext, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import './RewardsModal.module.css'
import Accordion from 'react-bootstrap/Accordion';
import { dataContext } from '../../../App';
import activityLogSubmission from '../../../helper/activitylog';
import analyticEvent from '../../../helper/gaEvent';
import { pushCleverTapEvent } from '../../../helper/clevertapFunction';
import styles from './RewardsModal.module.css'
import './RewardsModal.css'

const RewardsModal = ({ showRewardsModal, setShowRewardsModal }) => {
  const { playerData } = useContext(dataContext);

  function hideModalOperation() {
    setShowRewardsModal(false)
  }

  useEffect(() => {
    let msisdn = null;
    if (playerData?.id) {
      msisdn = playerData?.msisdn;
    }
    activityLogSubmission("rewards", msisdn);
    analyticEvent('rewards', 'rewards-view')
    // pushCleverTapEvent('CheckIn-Prize');
  }, [])

  return (
    <>
      <div className={styles.rewardsModal}>
        <div className={styles.rewardsModalHeader}>
          <img src={require('./rewards.png')} className={styles.rewardsModalIcon} alt="medal" />
          <span className={styles.rewardsModalTitle}>প্রাইজের তালিকা</span>
        </div>
        <div className={styles.specialNote} style={{marginTop: '10px' }}>
          <p>
            <b>বিশেষ দ্রষ্টব্য:</b> একটি নির্দিষ্ট bKash নম্বর দিয়েই Quizard-এর ৪টি দারুন সেগমেন্টে সাবস্ক্রিপশন করতে পারবেন।
            কুইজ প্রতিদিন  |  স্পোর্টস কুইজ |  BCS প্রস্তুতি  |  কুইজ টুর্নামেন্ট ! 
            <br />
            <br />
            তবে মনে রাখবেন, ওই bKash নম্বরের সাবস্ক্রিপশনগুলো থেকে প্রতি সেগমেন্টে শুধু একটি নম্বরই উইনার হিসেবে নির্বাচিত হবে!
          </p>
        </div>
        <Accordion className={styles.accordion}>
          <Accordion.Item eventKey="0" className={styles.accordionItem}>
            <Accordion.Header className={styles.accordionButton}>কুইজ প্রতিদিন পুরস্কার</Accordion.Header>
            <Accordion.Body className={styles.accordionBody}>
              <b>প্রতিদিন:</b> শীর্ষ ৫০ জন ১০ টাকা bKash ক্যাশ-ইন
              <br />
              <br />
              <b>সাপ্তাহিক :</b> শীর্ষ ১০ জন ৫০০ টাকা পর্যন্ত bKash ক্যাশ-ইন
              <br />
              <br />
              ***প্রতি সপ্তাহের রবিবার প্রাইজ দেয়া হয়ে থাকে।
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1" className={styles.accordionItem}>
            <Accordion.Header className={styles.accordionButton}>স্পোর্টস কুইজ পুরস্কার</Accordion.Header>
            <Accordion.Body className={styles.accordionBody}>
              <b>প্রতিদিন:</b> শীর্ষ ৪০ জন ১০ টাকা bKash ক্যাশ-ইন
              <br />
              <br />
              <b>সাপ্তাহিক:</b> শীর্ষ ১০ জন ৫০০ টাকা পর্যন্ত
              <br />
              <br />
              ***প্রতি সপ্তাহের রবিবার প্রাইজ দেয়া হয়ে থাকে।
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2" className={styles.accordionItem}>
            <Accordion.Header className={styles.accordionButton}>BCS প্রস্তুতি পুরস্কার</Accordion.Header>
            <Accordion.Body className={styles.accordionBody}>
              <b>প্রতিদিন:</b> শীর্ষ ৩০ জন ১০ টাকা bKash ক্যাশ-ইন
              <br />
              <br />
              <b>সাপ্তাহিক:</b> শীর্ষ ১০ জন ৫০০ টাকা পর্যন্ত
              <br />
              <br />
              ***প্রতি সপ্তাহের রবিবার প্রাইজ দেয়া হয়ে থাকে।
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3" className={styles.accordionItem}>
            <Accordion.Header className={styles.accordionButton}>কুইজ টুর্নামেন্ট পুরস্কার</Accordion.Header>
            <Accordion.Body className={styles.accordionBody}>
              <b>প্রতিদিন:</b> শীর্ষ ২০ জন ১০ টাকা bKash ক্যাশ-ইন
              <br />
              <br />
              ***প্রতি সপ্তাহের রবিবার প্রাইজ দেয়া হয়ে থাকে।
              <br />
              <br />
              টুর্নামেন্ট শেষে অংশগ্রহণকারীদের টোটাল স্কোর ও সময় গণনা করা হবে ।<br />
              সর্বনিম্ন সময়ে সর্বোচ্চ স্কোর ধারী ৫ জন কে মেগা পুরস্কার প্রদান করা হবে ।
              <ul>
                <li>১ম পুরস্কার:(Quiz King) টিভি (Samsung 32T4450 32" HD LED Smart TV)</li>
                <li>২য় পুরস্কার:(Quiz Champion) স্মার্টফোন (Samsung Galaxy A16 5G (6/128 GB))</li>
                <li>৩য় পুরস্কার: (Quiz Star) স্মার্টওয়াচ</li>
                <li>৪র্থ পুরস্কার: (Quiz Expert) ৩০০০ টাকা ক্যাশ ইন</li>
                <li>৫ম পুরস্কার:  (Quiz Challenger) ২০০০ টাকা ক্যাশ ইন পুরস্কার</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
          
          <Accordion.Item eventKey="8" className={styles.accordionItem}>
            <Accordion.Header className={styles.accordionButton}>২০% ক্যাশব্যাক  প্রাইজ</Accordion.Header>
            <Accordion.Body className={styles.accordionBody}>
              কুইজ প্রতিদিন,স্পোর্টস কুইজ,BCS প্রস্তুতি ও টুর্নামেন্ট বান্ডেল প্যাকেজে যারা পেইড সাবস্ক্রাইবড আছেন তারা ২০% ক্যাশব্যাক পাবেন।
              <br />
              <br />
              ***প্রতি সপ্তাহের রবিবার প্রাইজ দেয়া হয়ে থাকে।
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="5" className={styles.accordionItem}>
            <Accordion.Header className={styles.accordionButton}>১০ টাকা ক্যাশ ইন  প্রাইজ</Accordion.Header>
            <Accordion.Body className={styles.accordionBody}>
              আপনার রেফার কোড ব্যাবহার করে কেউ যদি সাবস্ক্রিপশন করে, তাহলে প্রতি সফল সাবস্ক্রিপশনে আপনি পেয়ে যাবেন ১০ টাকা ক্যাশ ইন।
              <br />
              <br />
              ***প্রতি সপ্তাহের রবিবার প্রাইজ দেয়া হয়ে থাকে।
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="6" className={styles.accordionItem}>
            <Accordion.Header className={styles.accordionButton}>১০ টাকা ক্যাশ ব্যাক প্রাইজ (Churn ইউজারদের জন্য)</Accordion.Header>
            <Accordion.Body className={styles.accordionBody}>
              Quizard এ যারা ৭দিন অথবা তার চেয়ে বেশি সময় ধরে আন্সাবস্ক্রাইব অবস্থায় আছেন তারা যদি আবার সাবস্ক্রিপশন করেন তাহলে তারা পাচ্ছেন ১০ টাকা ক্যাশ ব্যাক প্রাইজ। এই প্রাইজ সব প্যাকেজের জন্য প্রযোজ্য
              <br />
              <br />
              ***প্রতি সপ্তাহের রবিবার প্রাইজ দেয়া হয়ে থাকে।
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="7" className={styles.accordionItem}>
            <Accordion.Header className={styles.accordionButton}>৫ টাকা ক্যাশ ক্যাশ ব্যাক প্রাইজঃ (নিউ সাবস্ক্রাইবারদের জন্য)</Accordion.Header>
            <Accordion.Body className={styles.accordionBody}>
              Quizard এ  যেকোনো সেগমেন্ট এ সাবস্ক্রিপশন করলেই ইউজার পাবেন ৫ টাকা ক্যাশ ক্যাশ ব্যাক।
              <br />
              <br />
              ***প্রতি সপ্তাহের রবিবার প্রাইজ দেয়া হয়ে থাকে।
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </>
  )
}

export default RewardsModal